import type {
  App,
} from 'vue';

import {
  installTranslations,
} from './i18n/install.ts';
import type {
  TI18nInstance,
} from './i18n/interface.ts';

// Components
export {
  default as AppLoadingBar,
} from './components/app-loading-bar/app-loading-bar.vue';
export {
  default as AppNavbar,
} from './components/app-navbar/app-navbar.vue';
export {
  default as ButtonNav,
} from './components/app-navbar/button-nav.vue';
export {
  default as SeparatorAppNavbar,
} from './components/app-navbar/separator-app-navbar.vue';
export {
  default as AppOverview,
} from './components/app-overview/app-overview.vue';
export {
  default as AppTile,
} from './components/app-tile/app-tile.vue';
export {
  default as AppHeader,
} from './components/app/app-header.vue';
export {
  default as AppSidebar,
} from './components/app/app-sidebar.vue';
export {
  default as App,
} from './components/app/app.vue';
export {
  default as QmulusBreadcrumbItem,
} from './components/breadcrumb/qmulus-breadcrumb-item.vue';
export {
  default as QmulusBreadcrumb,
} from './components/breadcrumb/qmulus-breadcrumb.vue';
export {
  default as QmulusButtonGroup,
} from './components/button/qmulus-button-group.vue';
export {
  default as QmulusButton,
} from './components/button/qmulus-button.vue';
export {
  default as RadioButtonGroup,
} from './components/button/radio-button-group.vue';
export {
  default as SemanticButtonGroup,
} from './components/button/semantic-button-group.vue';
export {
  default as SemanticButton,
} from './components/button/semantic-button.vue';
export {
  default as QmulusCarousel,
} from './components/carousel/qmulus-carousel.vue';
export {
  default as CheckboxQmulus,
} from './components/checkbox-qmulus/checkbox-qmulus.vue';
export {
  default as QmulusDropdownOptionItem,
} from './components/dropdown/qmulus-dropdown-option-item.vue';
export {
  default as QmulusDropdown,
} from './components/dropdown/qmulus-dropdown.vue';
export {
  default as GridDetailsRow,
} from './components/grid-details/grid-details-row.vue';
export {
  default as GridDetails,
} from './components/grid-details/grid-details.vue';
export {
  default as InputDate,
} from './components/input-date/input-date.vue';
export {
  default as InputDatetime,
} from './components/input-datetime/input-datetime.vue';
export {
  default as InputDuration,
} from './components/input-duration/input-duration.vue';
export {
  default as InputMaskedNumber,
} from './components/input-masked-number/input-masked-number.vue';
export {
  default as InputNumber,
} from './components/input-number/input-number.vue';
export {
  default as InputNumericRange,
} from './components/input-numeric-range/input-numeric-range.vue';
export {
  default as InputPassword,
} from './components/input-password/input-password.vue';
export {
  default as InputSearch,
} from './components/input-search/input-search.vue';
export {
  default as InputText,
} from './components/input-text/input-text.vue';
export {
  default as InputTextarea,
} from './components/input-textarea/input-textarea.vue';
export {
  default as InputTime,
} from './components/input-time/input-time.vue';
export {
  default as LinkContactSupport,
} from './components/link-contact-support/link-contact-support.vue';
export {
  default as LinkWithIcon,
} from './components/link-with-icon/link-with-icon.vue';
export {
  default as LogoQmulus,
} from './components/logo-qmulus/logo-qmulus.vue';
export {
  default as MessageBox,
} from './components/message-box/message-box.vue';
export {
  default as ModalMergeConflictHost,
} from './components/modal-merge-conflict/modal-merge-conflict-host.vue';
export {
  default as ModalQmulus,
} from './components/modal-qmulus/modal-qmulus.vue';
export {
  default as MultiselectWithConfirm,
} from './components/multiselect-with-confirm/multiselect-with-confirm.vue';
export {
  default as OverlayLoading,
} from './components/overlay-loading/overlay-loading.vue';
export {
  default as PageQmulusHeader,
} from './components/page-qmulus/page-qmulus-header.vue';
export {
  default as PageQmulusTab,
} from './components/page-qmulus/page-qmulus-tab.vue';
export {
  default as PageQmulusTools,
} from './components/page-qmulus/page-qmulus-tools.vue';
export {
  default as PageQmulus,
} from './components/page-qmulus/page-qmulus.vue';
export {
  default as RadioCardGroup,
} from './components/radio-card-group/radio-card-group.vue';
export {
  default as ReactiveTooltip,
} from './components/reactive-tooltip/reactive-tooltip.vue';
export {
  default as ModalReleaseHighlights,
} from './components/release-highlights/modal-release-highlights.vue';
export {
  default as ReleaseHighlight,
} from './components/release-highlights/release-highlight.vue';
export {
  default as ReleaseHighlightsList,
} from './components/release-highlights/release-highlights-list.vue';
export {
  default as TabViewMenu,
} from './components/tab-view/tab-view-menu.vue';
export {
  default as TabView,
} from './components/tab-view/tab-view.vue';
export {
  default as TextCopy,
} from './components/text-copy/text-copy.vue';
export {
  default as TextKeyboardKey,
} from './components/text-keyboard-key/text-keyboard-key.vue';

// Node editor framework
export * from './components/qmulus-node-editor-framework/index.ts';

// Component type definitions
export type * from './components/breadcrumb/qmulus-breadcrumb.ts';
export type * from './components/button/qmulus-button.ts';
export type * from './components/button/radio-button-group.ts';
export type * from './components/button/semantic-button.ts';
export type * from './components/dropdown/qmulus-dropdown.ts';
export type * from './components/input-numeric-range/input-numeric-range.ts';
export type * from './components/radio-card-group/radio-card-group.ts';
export * from './components/release-highlights/release-highlights.ts';
export type * from './components/tab-view/tab-view.ts';

// Directives
export {
  default as QTooltip,
} from './directives/q-tooltip/q-tooltip.ts';
export type * from './directives/q-tooltip/q-tooltip.ts';
export type * from './directives/q-tooltip/q-tooltip-position.ts';

// Composables
export * from './composable/use-merge-conflict.ts';
export * from './composable/use-state-url.ts';

// Types
export * from './types/form.ts';
export type * from './types/notification.ts';
export * from './types/props.ts';
export * from './types/toast.ts';

// Utils
export * from './utils/changelog.ts';
export * from './utils/color.ts';
export * from './utils/common.ts';
export * from './utils/css.ts';
export * from './utils/date.ts';
export * from './utils/keyboard-key-symbol.ts';
export * from './utils/lru-cache.ts';
export * from './utils/object.ts';
export * from './utils/primevue-tag.ts';
export * from './utils/raf.ts';
export * from './utils/sequence-diff.ts';
export * from './utils/three-way-diff.ts';
export * from './utils/version.ts';
export * from './utils/vue.ts';
export * from './utils/zod.ts';

// API
export * from './api/authentication.ts';

// Constants
export * from './constants/color.ts';
export * from './constants/keyboard.ts';
export * from './constants/mutables.ts';
export * from './constants/primevue.ts';
export * from './constants/time.ts';

export interface TQmulusUiOptions {
  // Typed as TI18nInstance to accept any app-level i18n instance regardless of its message schema.
  i18n: TI18nInstance,
}

export default {
  install(_app: App, options: TQmulusUiOptions) {
    installTranslations(options.i18n);
  },
};
